module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/winpe-wob-independent-directors-dilemma.json
// module id = 1529
// module chunks = 228060444449267